import * as React from 'react';
import { FavouriteLayout } from 'app/area/favourite/components/favourite-layout';
import { FavouriteResult } from 'app/area/favourite/favourite-result';
import { FavouriteReplaceDomainNodes, FavouriteDefinition, AdminInfoData } from 'app/types-shared';
import { StatisticalReportExternalProps } from 'app/area/reports/types';
import { CaseReportExternalProps } from 'app/area/case-report/case-report-container';

interface FavouriteFiltersAndResultProps {
  hideFilters: boolean;
  hideFilterReplacements: boolean;
  adminPanelAccess?: AdminInfoData;
  isCreateReportOpen: boolean;
  updateExistingReport: boolean;
  initiallyOpenFilter: boolean;
  report: number;
  definition: FavouriteDefinition;
  workingDefinition: FavouriteDefinition;
  translation: any;
  getSearchRequiredUsers: () => void;
  onCloseReport: () => void;
  updateDefinition: (transform?: (definition: FavouriteDefinition) => FavouriteDefinition) => void;
  fetchingUpdateReplaceDomainNodes?: boolean;
  fetchingExtendedReplaceDomainNodes?: boolean;
  updateReplaceDomainNodes: (transform: (definition: FavouriteDefinition) => FavouriteDefinition, onSuccess: () => void) => void;
  loadExtendedReplaceDomainNodes: (favouriteId: number, onSuccess: (replaceDomainNodes: FavouriteReplaceDomainNodes[]) => void) => void;
  caseReportExternalProps?: CaseReportExternalProps;
  statisticalReportExternalProps?: StatisticalReportExternalProps;
  searchRequiredUsers: boolean;
  windowAsScrollableAncestor?: boolean;
}

export const FavouriteFiltersAndResult = ({
  hideFilters,
  hideFilterReplacements,
  adminPanelAccess,
  isCreateReportOpen,
  updateExistingReport,
  onCloseReport,
  updateDefinition,
  updateReplaceDomainNodes,
  loadExtendedReplaceDomainNodes,
  initiallyOpenFilter,
  report,
  definition,
  workingDefinition,
  translation,
  getSearchRequiredUsers,
  caseReportExternalProps,
  statisticalReportExternalProps,
  searchRequiredUsers,
  windowAsScrollableAncestor,
  fetchingUpdateReplaceDomainNodes,
  fetchingExtendedReplaceDomainNodes
}: FavouriteFiltersAndResultProps) => {
  
  const result = <FavouriteResult
    report={report}
    definition={definition}
    workingDefinition={workingDefinition}
    updateDefinition={updateDefinition}
    caseReportExternalProps={caseReportExternalProps}
    statisticalReportExternalProps={statisticalReportExternalProps}
    windowAsScrollableAncestor={windowAsScrollableAncestor}
  />;

  if (hideFilters) {
    return result;
  }

  return <FavouriteLayout
      isCreateReportOpen={isCreateReportOpen}
      updateExistingReport={updateExistingReport}
      closeReportCreator={onCloseReport}
      updateDefinition={updateDefinition}
      fetchingUpdateReplaceDomainNodes={fetchingUpdateReplaceDomainNodes}
      fetchingExtendedReplaceDomainNodes={fetchingExtendedReplaceDomainNodes}
      updateReplaceDomainNodes={updateReplaceDomainNodes}
      loadExtendedReplaceDomainNodes={loadExtendedReplaceDomainNodes}
      initiallyOpenFilter={initiallyOpenFilter}
      definition={definition}
      workingDefinition={workingDefinition}
      translation={translation}
      getSearchRequiredUsers={getSearchRequiredUsers}
      searchRequiredUsers={searchRequiredUsers}
      hideFilters={hideFilters}
      hideFilterReplacements={hideFilterReplacements}
      adminPanelAccess={adminPanelAccess}>
    {result}
  </FavouriteLayout>;
};
